module.exports = __webpack_public_path__ + "assets/icons/favicon-404a.ico";